import { amber, amberA, amberDark, amberDarkA, blue, blueA, blueDark, blueDarkA, green, greenA, greenDark, greenDarkA, indigo, indigoA, indigoDark, indigoDarkA, red, redA, redDark, redDarkA, ruby, rubyA, rubyDark, rubyDarkA, sand, sandA, sandDark, sandDarkA, violet, violetA, violetDark, violetDarkA } from "@radix-ui/colors";

//#region src/theme.ts
const colors = {
	accent1: violet.violet1,
	accent2: violet.violet2,
	accent3: violet.violet3,
	accent4: violet.violet4,
	accent5: violet.violet5,
	accent6: violet.violet6,
	accent7: violet.violet7,
	accent8: violet.violet8,
	accent9: violet.violet9,
	accent10: violet.violet10,
	accent11: violet.violet11,
	accent12: violet.violet12,
	accentA1: violetA.violetA1,
	accentA2: violetA.violetA2,
	accentA3: violetA.violetA3,
	accentA4: violetA.violetA4,
	accentA5: violetA.violetA5,
	accentA6: violetA.violetA6,
	accentA7: violetA.violetA7,
	accentA8: violetA.violetA8,
	accentA9: violetA.violetA9,
	accentA10: violetA.violetA10,
	accentA11: violetA.violetA11,
	accentA12: violetA.violetA12,
	...sand,
	...sandA,
	...green,
	...greenA,
	...red,
	...redA,
	...amber,
	...amberA,
	...ruby,
	...rubyA,
	...blue,
	...blueA,
	...indigo,
	...indigoA,
	background: "#fff",
	secondaryBackground: sand.sand1,
	accentContrast: "#fff"
};
const darkColors = {
	accent1: violetDark.violet1,
	accent2: violetDark.violet2,
	accent3: violetDark.violet3,
	accent4: violetDark.violet4,
	accent5: violetDark.violet5,
	accent6: violetDark.violet6,
	accent7: violetDark.violet7,
	accent8: violetDark.violet8,
	accent9: violetDark.violet9,
	accent10: violetDark.violet10,
	accent11: violetDark.violet11,
	accent12: violetDark.violet12,
	accentA1: violetDarkA.violetA1,
	accentA2: violetDarkA.violetA2,
	accentA3: violetDarkA.violetA3,
	accentA4: violetDarkA.violetA4,
	accentA5: violetDarkA.violetA5,
	accentA6: violetDarkA.violetA6,
	accentA7: violetDarkA.violetA7,
	accentA8: violetDarkA.violetA8,
	accentA9: violetDarkA.violetA9,
	accentA10: violetDarkA.violetA10,
	accentA11: violetDarkA.violetA11,
	accentA12: violetDarkA.violetA12,
	...sandDark,
	...sandDarkA,
	...greenDark,
	...greenDarkA,
	...redDark,
	...redDarkA,
	...amberDark,
	...amberDarkA,
	...rubyDark,
	...rubyDarkA,
	...blueDark,
	...blueDarkA,
	...indigoDark,
	...indigoDarkA,
	background: sandDark.sand1,
	secondaryBackground: sandDark.sand2,
	accentContrast: "#fff"
};
const spacing = {
	xxxs: 2,
	xxs: 4,
	xs: 6,
	sm: 10,
	md: 12,
	lg: 16,
	xl: 20,
	xxl: 24,
	xxxl: 32,
	xxxxl: 40
};
const borderWidths = {
	md: 1,
	lg: 1.5
};
const borderRadiuses = {
	sm: 4,
	md: 6,
	lg: 8,
	xl: 16,
	full: 99999
};
const lightShadows = {
	inset: `
  inset 0 0 0 1px rgba(0, 0, 0, 0.06),
  inset 0 1px 2px 0 rgba(0, 0, 0, 0.04)`,
	subtle: `
  0 0 0 1px rgba(0, 0, 0, 0.06),
  0 1px 1px -0.5px rgba(0, 0, 0, 0.06),
  0 3px 3px -1.5px rgba(0, 0, 0, 0.06)`,
	default: `
  0 0 0 1px rgba(0, 0, 0, 0.06),
  0 1px 1px -0.5px rgba(0, 0, 0, 0.06),
  0 3px 3px -1.5px rgba(0, 0, 0, 0.06),
  0 6px 6px -3px rgba(0, 0, 0, 0.06)`,
	elevated: `
  0 0 0 1px rgba(0, 0, 0, 0.06),
  0 1px 1px -0.5px rgba(0, 0, 0, 0.06),
  0 3px 3px -1.5px rgba(0, 0, 0, 0.06),
  0 6px 6px -3px rgba(0, 0, 0, 0.06),
  0 12px 12px -6px rgba(0, 0, 0, 0.04)`,
	strong: `
  0 0 0 1px rgba(0, 0, 0, 0.06),
  0 1px 1px -0.5px rgba(0, 0, 0, 0.06),
  0 3px 3px -1.5px rgba(0, 0, 0, 0.06),
  0 6px 6px -3px rgba(0, 0, 0, 0.06),
  0 12px 12px -6px rgba(0, 0, 0, 0.04),
  0 24px 24px -12px rgba(0, 0, 0, 0.04)`,
	hero: `
  0 0 0 1px rgba(0, 0, 0, 0.06),
  0 1px 1px -0.5px rgba(0, 0, 0, 0.06),
  0 3px 3px -1.5px rgba(0, 0, 0, 0.06),
  0 6px 6px -3px rgba(0, 0, 0, 0.06),
  0 12px 12px -6px rgba(0, 0, 0, 0.04),
  0 24px 32px -12px rgba(0, 0, 0, 0.03),
  0 48px 64px -24px rgba(0, 0, 0, 0.02)`,
	tinted: (tintColor = "rgba(0, 0, 0, 0.06)") => `0 4px 12px ${tintColor}`
};
const darkShadows = {
	inset: `
  inset 0 0 0 1px rgba(255, 255, 255, 0.08),
  inset 0 1px 2px 0 rgba(0, 0, 0, 0.12)`,
	subtle: `
  0 0 0 1px rgba(255, 255, 255, 0.08),
  0 1px 1px -0.5px rgba(0, 0, 0, 0.12),
  0 3px 3px -1.5px rgba(0, 0, 0, 0.12)`,
	default: `
  0 0 0 1px rgba(255, 255, 255, 0.08),
  0 1px 1px -0.5px rgba(0, 0, 0, 0.12),
  0 3px 3px -1.5px rgba(0, 0, 0, 0.12),
  0 6px 6px -3px rgba(0, 0, 0, 0.12)`,
	elevated: `
  0 0 0 1px rgba(255, 255, 255, 0.08),
  0 1px 1px -0.5px rgba(0, 0, 0, 0.12),
  0 3px 3px -1.5px rgba(0, 0, 0, 0.12),
  0 6px 6px -3px rgba(0, 0, 0, 0.12),
  0 12px 12px -6px rgba(0, 0, 0, 0.08)`,
	strong: `
  0 0 0 1px rgba(255, 255, 255, 0.08),
  0 1px 1px -0.5px rgba(0, 0, 0, 0.12),
  0 3px 3px -1.5px rgba(0, 0, 0, 0.12),
  0 6px 6px -3px rgba(0, 0, 0, 0.12),
  0 12px 12px -6px rgba(0, 0, 0, 0.08),
  0 24px 24px -12px rgba(0, 0, 0, 0.08)`,
	hero: `
  0 0 0 1px rgba(255, 255, 255, 0.08),
  0 1px 1px -0.5px rgba(0, 0, 0, 0.12),
  0 3px 3px -1.5px rgba(0, 0, 0, 0.12),
  0 6px 6px -3px rgba(0, 0, 0, 0.12),
  0 12px 12px -6px rgba(0, 0, 0, 0.08),
  0 24px 32px -12px rgba(0, 0, 0, 0.06),
  0 48px 64px -24px rgba(0, 0, 0, 0.04)`,
	tinted: (tintColor = "rgba(0, 0, 0, 0.12)") => `0 4px 12px ${tintColor}`
};
const textWeights = {
	light: 300,
	normal: 400,
	medium: 500,
	semibold: 560,
	bold: 700
};
const fontStyles = {
	xxxl: {
		fontSize: 28,
		lineHeight: "36px",
		letterSpacing: "-0.0075em"
	},
	xxl: {
		fontSize: 24,
		lineHeight: "30px",
		letterSpacing: "-0.00625em"
	},
	xl: {
		fontSize: 20,
		lineHeight: "28px",
		letterSpacing: "-0.005em"
	},
	lg: {
		fontSize: 18,
		lineHeight: "26px",
		letterSpacing: "-0.0025em"
	},
	md: {
		fontSize: 15,
		lineHeight: "22px",
		letterSpacing: "0"
	},
	sm: {
		fontSize: 13,
		lineHeight: "18px",
		letterSpacing: "0"
	},
	xs: {
		fontSize: 11,
		lineHeight: "16px",
		letterSpacing: "0.0025em"
	},
	xxs: {
		fontSize: 9,
		lineHeight: "12px",
		letterSpacing: "0.025em"
	},
	prose: {
		fontSize: 15,
		lineHeight: "24px",
		letterSpacing: "0"
	},
	"prose-sm": {
		fontSize: 13,
		lineHeight: "21px",
		letterSpacing: "0"
	},
	tight: {
		fontSize: 15,
		lineHeight: "18px",
		letterSpacing: "0"
	}
};
const fontFamilies = {
	Newsreader: `"Newsreader", serif`,
	Inter: `"Inter", system-ui, sans-serif`
};
const transitions = {
	fast: {
		duration: 130,
		easing: "ease-in-out"
	},
	normal: {
		duration: 200,
		easing: "ease-in-out"
	},
	slow: {
		duration: 300,
		easing: "ease-in-out"
	}
};
const breakpoints = {
	mobile: 768,
	tablet: 1024
};
const lightTheme = {
	name: "light",
	colors,
	spacing,
	borderWidths,
	borderRadiuses,
	fontStyles,
	textWeights,
	fontFamilies,
	shadows: lightShadows,
	transitions,
	breakpoints
};
const darkTheme = {
	name: "dark",
	colors: darkColors,
	spacing,
	borderWidths,
	borderRadiuses,
	fontStyles,
	textWeights,
	fontFamilies,
	shadows: darkShadows,
	transitions,
	breakpoints
};
/**
* These are chosen to work well with the respective text font sizes.
* Sizes are intentionally close to text sizes for balanced visual weight.
*/
const iconSizes = {
	xxs: 11,
	xs: 13,
	sm: 15,
	md: 17,
	lg: 20,
	xl: 24
};

//#endregion
export { darkTheme, fontFamilies, iconSizes, lightTheme, textWeights };